export default () => {
  return {
    namespaced: true,
    state: {
      extraInfo: '',
      extraInfoSelectState: false,
      priceQoute: false,
      acceptedAi: true
    },
    mutations: {
      setExtraInfo(state, value) {
        state.extraInfo = value;
      },
      setAcceptedAi(state, value) {
        state.acceptedAi = value;
      },
      setExtraInfoSelectState(state, value) {
        state.extraInfoSelectState = value;
      },
      setPriceQoute(state, data) {
        state.priceQoute = data;
      },
      clearStore(state) {
        state.extraInfo = '';
        state.extraInfoSelectState = false;
        state.priceQoute = false;
        state.acceptedAi = true;
      }
    }
  };
};
